import { CLUSTERS_FIELDS } from 'shared/constants/map';
import { ViewedClustersService } from 'shared/services/ViewedClustersService';
import { Cluster, RBushItem } from 'shared/types/Map';

const viewedClustersService = new ViewedClustersService();

export const convertClusterToRBushItem = (cluster: Cluster): RBushItem => {
  const [x, y] = cluster.geometry.coordinates;

  /**
   * @todo убрать добавление флага "isViewed", когда будет сделана реализация на бэке.
   */
  const isViewed = viewedClustersService.getIsClusterViewed(cluster.id);

  if (isViewed) {
    cluster.properties ??= {};
    cluster.properties[CLUSTERS_FIELDS.isViewed] = 1;
  }

  return {
    cluster,
    maxX: x,
    maxY: y,
    minX: x,
    minY: y,
  };
};
